import config from "../../config"
import RequestService from "../RequestService"

const fetchWaiver = (id, successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrlV2}/waivers/${id}`, successCallback, failureCallback)
}

export default fetchWaiver;